// حفظ ملف (Excel/PDF…) يعمل على الويب وتطبيق الهاتف (Capacitor) معاً.
// الويب: تنزيل عبر رابط <a download>. الجوال: حفظ في Documents ثم فتح طبقة النظام (معاينة/فتح/مشاركة)
// فلا يغادر المستخدم التطبيق، وبهذا يعمل زرّا Excel/الكشف على الهاتف (كانا لا يحفظان شيئاً داخل WebView).
const isNative = () => {
  try {
    return window.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
};

const toB64 = (blob) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onloadend = () => res(String(r.result).split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(blob);
  });

const webSave = (blob, name) => {
  const u = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: u, download: name });
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { a.remove(); URL.revokeObjectURL(u); }, 4000);
};

export const saveBlob = async (blob, name) => {
  if (!isNative()) {
    webSave(blob, name);
    return "downloaded";
  }
  const { Filesystem, Directory } = await import("@capacitor/filesystem");
  const w = await Filesystem.writeFile({ path: name, data: await toB64(blob), directory: Directory.Documents });
  try {
    const { Share } = await import("@capacitor/share");
    await Share.share({ title: name, url: w.uri });
  } catch { /* عارض غير متاح — الملف محفوظ في المستندات */ }
  return "saved";
};
